<template>
    <form-view class="audio-service-form-view" @submitsuccess="back">
        <template slot="field">
            <veui-field label="应用名称："
                name="appId"
                field="appId"
                :readonly="!!store.createForFixedAppId || isDetail"
                :disabled="isEdit"
                rules="required">
                <search-select
                    :options="store.appDatasource"
                    v-model="store.formData.appId"
                    placeholder="请选择"/>
                    <veui-button v-if="isCreate" @click="goToCreateApp" ui="link">新建应用</veui-button>
            </veui-field>
           <veui-field label="服务名称："
                name="name"
                field="name"
                :readonly="isDetail"
                :disabled="!isEditDraft && !isCreate"
                :rules="validator('required|name|maxLength:20')"
                tip="最多可输入20个字符">
                <veui-input
                    v-model="store.formData.name"
                    placeholder="数字、字母、汉字"/>
            </veui-field>
            <veui-field label="语言设置：" name="lan" field="lan" rules="required">
                <veui-radio-group
                    :readonly="isDetail"
                    :items="store.languageDatasource"
                    v-model="store.formData.lan"/>
            </veui-field>
            <veui-field label="语速设置：" name="speed" field="speed" rules="required">
                <veui-select :options="store.speakSpeedDatasource"
                    :readonly="isDetail"
                    v-model="store.formData.speed"/>
            </veui-field>
            <veui-field label="语调设置：" name="intonation" field="intonation" rules="required">
                <veui-select :options="store.volumeDatasource"
                    :readonly="isDetail"
                    v-model="store.formData.intonation"/>
            </veui-field>
            <veui-field label="音量设置：" name="volume" field="volume" rules="required">
                <veui-select :options="store.volumeDatasource"
                    :readonly="isDetail"
                    v-model="store.formData.volume"/>
            </veui-field>
            <veui-field label="音色设置：" name="timbre" field="timbre" rules="required">
                <veui-radio-group
                    :items="store.timbreDatasource"
                    v-model="store.formData.timbre"/>
            </veui-field>
            <veui-field label="测试文本：" name="text" field="text"
                tip="输入需要试听播放的内容，最多可输入500个字符">
                <veui-textarea
                    v-model="store.formData.text"/>
            </veui-field>
            <div class="audio-demo">
                <veui-button :disabled="!store.formData.text" @click="store.reuqestDemo()">生成试听音频</veui-button>
                <veui-span class="demo-tip">该文本仅用来测试音频的播放效果，非实际投放要播放的文本内容</veui-span>
                <muse-audio v-if="store.audioDemo" auto-play class="muse-audio-player" :src="store.audioDemo"/>
            </div>
        </template>
        <template slot="operation">
            <template v-if="!isDetail">
                <veui-button ui="primary" type="submit"
                    @click="store.formData.submitType='publish'">提交发布</veui-button>
                <veui-button class="primary-border-btn"
                    type="submit"
                    @click="store.formData.submitType='save'">保存为草稿</veui-button>
            </template>
            <veui-button @click="back">{{ cancelText }}</veui-button>
        </template>
    </form-view>
</template>

<script>
import FormView from '@baidu/ve-ria/views/FormView';
import FormModel from './FormModel';
import createView from '@baidu/ve-ria/views/createView';
import {Field, RadioGroup, Button, Input, Span, Select, Textarea} from 'veui';
import SearchSelect from '@/common/components/SearchSelect';
import serviceMixin from '@/common/mixins/service';
import Audio from '@/common/components/media/Audio';

export default createView(FormView, FormModel, {
    name: 'AudioServiceFormView',
    components: {
        'veui-field': Field,
        'veui-input': Input,
        'veui-span': Span,
        'veui-button': Button,
        'veui-select': Select,
        'veui-radio-group': RadioGroup,
        'veui-textarea': Textarea,
        'muse-audio': Audio,
        SearchSelect
    },
    mixins: [serviceMixin]
});
</script>

<style lang="less">
.audio-service-form-view {
    .audio-demo {
        display: block;
        margin-left: 120px
    }
    .demo-tip {
        margin-left: 10px;
    }
    .muse-audio-player {
        width: 500px;
    }
}
</style>
